import { Action } from "@ngrx/store";
import { NavigationExtras } from "@angular/router";

import { Category } from "src/app/routes/catalog/models/category.model";
import { Product } from "src/app/routes/catalog/models/product.model";
import { Page } from "../../models/page.model";
import { Screen } from "../../models/screen.model";

export enum TYPES {
  GO = "[Core] Go",
  BACK = "[Core] Back",
  FORWARD = "[Core] Forward",
  SET_SCREEN = "[Core] Set Screen",
  SET_BREADCRUMB = "[Core] Set Breadcrumb",
  SET_SCROLLPOSITION = "[Core] Set ScrollPosition",
}

/**
 * Screen
 */
const MOBILE_MAX_WIDTH = 600;
const TABLET_MAX_WIDTH = 1000;

export class SetScreen implements Action {
  readonly type = TYPES.SET_SCREEN;
  screen: Readonly<Screen>;

  public constructor(width: number) {
    const mobile = width <= MOBILE_MAX_WIDTH;
    const tablet = width <= TABLET_MAX_WIDTH && width > MOBILE_MAX_WIDTH;
    this.screen = {
      mobile,
      tablet,
      desktop: !mobile && !tablet,
    };
  }
}

/*
 * Breadcrumb
 */
export class SetBreadcrumb implements Action {
  readonly type = TYPES.SET_BREADCRUMB;
  breadcrumb: Category | Product | Page;

  public constructor(breadcrumb: Category | Product | Page) {
    this.breadcrumb = breadcrumb;
  }
}

export class SetScrollPosition implements Action {
  readonly type = TYPES.SET_SCROLLPOSITION;
  scrollPosition: number;

  public constructor(scrollPosition: number) {
    this.scrollPosition = scrollPosition;
  }
}

/*
 * Navigation
 */
export class Go implements Action {
  readonly type = TYPES.GO;

  constructor(
    public payload: {
      path: any[];
      query?: object;
      extras?: NavigationExtras;
    },
  ) {}
}

export class Back implements Action {
  readonly type = TYPES.BACK;
}

export class Forward implements Action {
  readonly type = TYPES.FORWARD;
}

export type Union =
  | SetScreen
  | Go
  | Back
  | Forward
  | SetBreadcrumb
  | SetScrollPosition;
